import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getOrderReview, submitDropship } from '@/lib/api/orderReview'

/** Order Review detail for a single Shopify order. */
export function useOrderReview(shopifyOrderId: string) {
  return useQuery({
    queryKey: ['orderReview', shopifyOrderId],
    queryFn: () => getOrderReview(shopifyOrderId),
    enabled: shopifyOrderId.length > 0,
    staleTime: 30_000,
  })
}

/** Submit selected line items to KH. On success, invalidate the queue. */
export function useSubmitDropship() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: submitDropship,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['queue'] })
    },
  })
}
